import { useTheme } from "@mui/material/styles";

export function CrossCheckMarkIcon() {
  const { palette } = useTheme();
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.33864 16.9661L17.6523 5.65234"
        stroke={palette.error.main}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6.34766 5.65234L17.6614 16.9661"
        stroke={palette.error.main}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
